import { render, staticRenderFns } from "./parameters.vue?vue&type=template&id=f39bb930&scoped=true&"
import script from "./parameters.vue?vue&type=script&lang=js&"
export * from "./parameters.vue?vue&type=script&lang=js&"
import style0 from "./parameters.vue?vue&type=style&index=0&id=f39bb930&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39bb930",
  null
  
)

export default component.exports